import '../styles/EnvBadge.css';

/* Hosts that are the real shop. Anything else is a test deployment. */
const PRODUCTION_HOSTS = ['celestialstones.in', 'www.celestialstones.in'];

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', '[::1]'];

/**
 * Which environment is this page being served from?
 * Decided from the hostname at runtime, so it needs no build-time
 * configuration and cannot get out of step with the deployment.
 *
 * Exported separately from the component so it can be tested directly.
 */
export const environmentFor = (hostname = '') => {
  const host = String(hostname).toLowerCase();
  if (PRODUCTION_HOSTS.includes(host)) return null; // the real shop
  if (LOCAL_HOSTS.includes(host)) return 'LOCAL';
  return 'STAGING'; // *.vercel.app and anything else
};

/**
 * Small corner marker so it's obvious which copy of the site you're
 * looking at — the staging and production builds are otherwise
 * identical, and both talk to the same database, so an order placed on
 * the wrong one is a real order.
 *
 * Deliberately renders NOTHING on the production domain, so merging
 * this to main is harmless.
 */
export default function EnvBadge() {
  const env = environmentFor(
    typeof window === 'undefined' ? '' : window.location.hostname
  );

  if (!env) return null;

  return (
    <div className={`env-badge env-badge-${env.toLowerCase()}`} aria-hidden="true">
      {env}
    </div>
  );
}
